export default __webpack_public_path__ + "static/media/vue.75a090d3.JPG";